module.exports = __webpack_public_path__ + "img/icon-scene-1.77befd26.png";